(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["app-install-floating"] && !Shopify.designMode) return;
  try {
    (() => {
      const popup = document.querySelector('[data-app-offer]');
      if (!popup) return;

      const launcher = document.querySelector('[data-app-offer-open]');
      const panel = popup.querySelector('.app-offer__panel');
      const closeControls = popup.querySelectorAll('[data-app-offer-close]');
      const copyButton = popup.querySelector('[data-app-offer-copy]');
      const copyStatus = popup.querySelector('[data-app-offer-copy-status]');

      const close = () => {
        popup.hidden = true;
        document.body.classList.remove('app-offer-open');
        launcher.focus();
      };

      const openPopup = () => {
        popup.hidden = false;
        document.body.classList.add('app-offer-open');
        window.requestAnimationFrame(() => panel.focus());
      };

      const positionLauncher = () => {
        const headerCandidates = document.querySelectorAll(
          '.shopify-section-group-header-group, #shopify-section-header, .header-wrapper, header'
        );
        const headerBottom = Array.from(headerCandidates).reduce((lowestEdge, header) => {
          const rectangle = header.getBoundingClientRect();
          const isVisible = rectangle.bottom > 0 && rectangle.top < window.innerHeight;
          return isVisible ? Math.max(lowestEdge, rectangle.bottom) : lowestEdge;
        }, 0);
        launcher.style.setProperty('--app-offer-launcher-top', `${Math.max(12, headerBottom + 12)}px`);
      };

      let positionFrame;
      const scheduleLauncherPosition = () => {
        if (positionFrame) return;
        positionFrame = window.requestAnimationFrame(() => {
          positionLauncher();
          positionFrame = null;
        });
      };

      const fallbackCopy = (text) => {
        const field = document.createElement('textarea');
        field.value = text;
        field.setAttribute('readonly', '');
        field.style.position = 'fixed';
        field.style.opacity = '0';
        document.body.appendChild(field);
        field.select();
        document.execCommand('copy');
        field.remove();
      };

      const copyCode = async () => {
        const code = copyButton.dataset.offerCode;
        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(code);
          } else {
            fallbackCopy(code);
          }
          copyStatus.textContent = copyButton.dataset.copiedLabel;
          copyButton.classList.add('is-copied');
          window.setTimeout(() => copyButton.classList.remove('is-copied'), 1400);
        } catch (error) {
          fallbackCopy(code);
          copyStatus.textContent = copyButton.dataset.copiedLabel;
          copyButton.classList.add('is-copied');
          window.setTimeout(() => copyButton.classList.remove('is-copied'), 1400);
        }
      };

      launcher.addEventListener('click', openPopup);
      copyButton.addEventListener('click', copyCode);
      closeControls.forEach((control) => control.addEventListener('click', close));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !popup.hidden) close();
      });
      window.addEventListener('resize', scheduleLauncherPosition);
      window.addEventListener('scroll', scheduleLauncherPosition, { passive: true });
      scheduleLauncherPosition();
    })();
  } catch(e) { console.error(e); }
})();

})();
